import { useEffect, useState, memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getPedido, putPedido } from '../../store/Pedidos';
import { Accordion, Dropdown, Table, FloatingLabel, Form, Modal, Button } from 'react-bootstrap';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { postRevisaoCarrinho } from '../../store/Carrinho';
import { deleteCondpag, selectCondPag } from '../../store/CondPagamento';
import { deleteCliente } from '../../store/Clientes';
import { deleteTransp } from '../../store/Transportadora';
import { deleteTabPreco } from '../../store/Preco';
import { MdOutlineShoppingCart, MdAdd } from "react-icons/md";
import LoadingIcon from '../../components/loading/Loading';
import { convertDecimal } from '../../function/maskInputMoney';
import { converterData } from '../../function/convertData';
import { checkToken } from '../../store/Usuarios';
import api from "../../services/api";
import logoPromexMais from "../../images/LogoPromexMais.png";
import { deleteCarrinho } from '../../store/Carrinho';
import { IoAdd, IoRemove, IoEllipse, IoClose, IoCheckmarkSharp, IoPencil, IoMailOpenOutline, IoDownload } from "react-icons/io5";

const empresa = process.env.REACT_APP_NAME;
const logo = process.env.REACT_APP_LOGO;

// ModalCheck é definido fora (ou pode ser memoizado)
const ModalCheck = memo(({ openModel, header, check, onHide, loadingEmail, loadingSubmit }) => {
    return (
        <Modal
            show={openModel}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton className="bg-yellow-500">
                <Modal.Title>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center align-items-center">
                {loadingSubmit && <LoadingIcon />}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loadingEmail || loadingSubmit}
                    variant="secondary"
                    onClick={check}
                >
                    {loadingEmail || loadingSubmit ? (
                        <div className="d-flex align-items-center">
                            <LoadingIcon />
                            <span className="ml-2">Processando</span>
                        </div>
                    ) : (
                        "Confirmar"
                    )}
                </Button>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
});

const Orcamento = () => {
    const { select } = useSelector(state => state.filialReduce);
    const { dataPedido, page, hasNext, loading } = useSelector(state => state.pedidoReduce);
    const { dataUser, selectUser } = useSelector(state => state.userReduce);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [typeSearch, settypeSearch] = useState({ tittle: "Nome Cliente", type: 3, term: "" });
    const [typeStatus, setTypeStatus] = useState({ title: "Todos", status: "" });

    useEffect(() => {
        dataUser.length > 1 ? 
            dispatch(getPedido(select.idFilial, "", typeStatus, typeSearch, page))
            :
            dispatch(getPedido(select.idFilial, selectUser.IdErpUser, typeStatus, typeSearch, page));
        dispatch(deleteCondpag());
        dispatch(deleteCliente());
        dispatch(deleteTransp());
        dispatch(deleteTabPreco());
    }, [select, page, typeSearch.type, typeStatus, selectUser]);

    const searchTerm = (term, page) => {
        settypeSearch({ ...typeSearch, term });
        dataUser.length > 1 ? 
            dispatch(getPedido(select.idFilial, "", typeStatus, { ...typeSearch, term }, page))
            :
            dispatch(getPedido(select.idFilial, selectUser.IdErpUser, typeStatus, { ...typeSearch, term }, page));
    };

    const setPage = (page) => {
        dataUser.length > 1 ? 
            dispatch(getPedido(select.idFilial, "", typeStatus, typeSearch, page))
            :
            dispatch(getPedido(select.idFilial, selectUser.IdErpUser, typeStatus, typeSearch, page));
    };

    const onClick = (value) => {
        switch (value) {
            case 1:
                settypeSearch({ ...typeSearch, tittle: "Número cotação", type: 1 });
                break;
            case 2:
                settypeSearch({ ...typeSearch, tittle: "Código cliente", type: 2 });
                break;
            case 3:
                settypeSearch({ ...typeSearch, tittle: "Nome cliente", type: 3 });
                break;
            default:
                break;
        }
    };

    const onClickStatus = (title, value) => {
        setTypeStatus({ title: title, status: value });
    };

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                color: color,
                backgroundColor: color,
                height: 2,
                width: '100%',
                margin: 4
            }}
        />
    );

    const gradientBackground = {
        background: 'linear-gradient(to right, #f7941e, #cc7b17)'
    };

    const inputStyles = {
        outline: 'none',
        borderRadius: '3px',
    };

    const btnInc = {
        borderWidth: '1px',
        borderStyle: 'solid',
        fontWeight: 600,
        borderImage: 'linear-gradient(to right, #d9005c, rgb(71, 165, 219)) 1 / 1 / 0 stretch',
        color: '#d9005c'
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-sm-6">
                    <p className="fw-semibold fs-2 m-0">Cotações</p>
                </div>
                <div className="col-md-3 d-flex align-items-center p-1 justify-center">
                    <Dropdown>
                        <Dropdown.Toggle variant="Secondary" id="dropdown-basic-stats">
                            Status: {typeStatus.title}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => onClickStatus("Todos", "")}>Todos</Dropdown.Item>
                            <Dropdown.Item onClick={() => onClickStatus("Aguardando", 0)}>
                                <div className="flex flex-row align-middle text-center">
                                    <div className="flex w-4 h-4 bg-gray-400 rounded-full self-center mr-3" />
                                    Aguardando
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => onClickStatus("Fila integração", 1)}>
                                <div className="flex flex-row align-middle text-center">
                                    <div className="flex w-4 h-4 bg-blue-400 rounded-full self-center mr-3" />
                                    Fila integração
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => onClickStatus("Aprovado", 2)}>
                                <div className="flex flex-row align-middle text-center">
                                    <div className="flex w-4 h-4 bg-green-400 rounded-full self-center mr-3" />
                                    Aprovado
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => onClickStatus("Reprovado", 3)}>
                                <div className="flex flex-row align-middle text-center">
                                    <div className="flex w-4 h-4 bg-yellow-400 rounded-full self-center mr-3" />
                                    Reprovado
                                </div>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="col-md-3 d-flex align-items-center p-1">
                    <Dropdown>
                        <Dropdown.Toggle variant="Secondary" id="dropdown-basic" className="px-05">
                            {typeSearch.tittle}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => onClick(1)}>Número cotação</Dropdown.Item>
                            <Dropdown.Item onClick={() => onClick(2)}>Código cliente</Dropdown.Item>
                            <Dropdown.Item onClick={() => onClick(3)}>Nome Cliente</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <input 
                        type="text" 
                        id="table-search" 
                        className="outline-gray-300 p-2 pl-10 w-full text-sm text-gray-900 bg-gray-50 rounded-r-lg" 
                        placeholder="Pesquisar..." 
                        onChange={(event) => searchTerm(event.target.value.toUpperCase(), 0)}
                        style={inputStyles}
                    />
                </div>
            </div>
            <ColoredLine color="#4ba3de" />

            {loading ? (
                <div className="d-flex justify-content-center my-5">
                    <LoadingIcon />
                </div>
            ) : (
                <Accordion flush className="w-100">
                    {dataPedido.map((item) => (
                        <AccordionPedidos item={item} key={item.codPedido + item.revisao} />
                    ))}
                </Accordion>
            )}

            <div className="container">
                <div className="row justify-end my-2">
                    {page > 0 && (
                    <div className="col-md-2">
                        <Button
                            variant=""
                            style={btnInc}
                            size="sm"
                            className="w-100 px-3 d-flex align-items-center justify-content-center rounded btn"
                            onClick={() => setPage(page - 1)}
                        >
                            <IoRemove />
                            Anterior
                        </Button>
                    </div>
                    )}
                    {hasNext && (
                    <div className="col-md-2">
                        <Button
                            variant=""
                            style={btnInc}
                            size="sm"
                            className="w-100 px-3 d-flex align-items-center justify-content-center rounded btn"
                            onClick={() => setPage(page + 1)}
                            disabled={!hasNext}
                        >
                            <IoAdd />
                            Próxima
                        </Button>
                    </div>
                    )}
                </div>
            </div>

            <div className="fixed bottom-8 right-8 z-10">
                <button 
                    style={gradientBackground} 
                    className="bg-blue-500 text-white p-4 rounded-full flex items-center justify-center space-x-2" 
                    onClick={() => {
                        dispatch(deleteCarrinho('', true));
                        navigate("/orcamentos/incluir");
                    }}
                >
                    <MdAdd size='30' />
                </button>
            </div>
        </div>
    );
};

export default Orcamento;

const AccordionPedidos = ({ item }) => {
    const [dataCliente, setdataCliente] = useState([]);
    const { dataPedido } = useSelector(state => state.pedidoReduce);
    const { dataUser, selectUser } = useSelector(state => state.userReduce);
    const [show, setShow] = useState(false);
    // Agora cada item tem seu próprio estado de modal
    const [showCheck, setShowCheck] = useState({ open: false, tittleModel: "", type: "" });
    const [toEmail, setToEmail] = useState(item.email);
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [erroMassage, setErroMassage] = useState({});
    const [detPedido, setDetPedido] = useState({ detCondPag: "", detTransp: "", detRedesp: "" });
    let codigoPedido = item.codPedido.substring(3, item.codPedido.length);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const totalCarrrinho = item.itens.reduce((total, currentItem) => {
        return total + ((currentItem.quantidade * currentItem.preco) - currentItem.desconto) * ((currentItem.ipi / 100) + 1);
    }, 0);

    const styles = StyleSheet.create({
        page: {
          flexDirection: 'column',
          backgroundColor: '#E4E4E4'
        },
        header: {
            display: 'flex',
            width: '100%',
            flexDirection: "row",
            justifyContent: "space-between",
        },
        tableHeader: {
            flexDirection: 'row',
            width: '100%',
            borderBottom: "0.5",
            borderBottomColor: "gray"
        },
        section: {
          margin: "2 2",
          padding: 1,
          flexGrow: 1,
        },
        titulo: {
            fontSize: 20,
            textAlign: "center",
            margin: 10,
        },
        texto: {
            margin: 5,
            fontSize: 15
        },
        textTbHeader: {
            margin: 5,
            fontSize: 12
        },
        textTbRow: {
            margin: 5,
            fontSize: 10
        },
        tableRow: {
            display: 'flex',
            width: '100%',
        },
        table: {
            display: 'flex',
            width: '100%',
            border: 0.5,
            marginTop: '20'
        },
        row: {
            display: 'flex',
            flexDirection: 'row',
            marginVertical: "0",
            paddingVertical: "0",
            borderBottom: "0.5",
            borderBottomColor: "gray"
        },
        logo: {
            width: '30%',
        },
    });
      

    const enviaEmail = async () => {
        setLoadingEmail(true);
        const formatarData = (data) => {
            const ano = data.substring(0, 4);
            const mes = data.substring(4, 6);
            const dia = data.substring(6, 8);
            return `${dia}/${mes}/${ano.substring(2, 4)}`;
        };
        const getTotalCarrinho = () => {
        const total = item.itens.reduce((acc, item) => {
                return (
                acc +
                ((item.preco * item.quantidade - item.desconto) *
                    ((item.ipi / 100) + 1))
                );
            }, 0);
            return convertDecimal(total.toFixed(2));
        };
        const formToPDF = {
            cliente: item.cliente.nmCliente,
            cotacao: item.codPedido.substring(3),
            revisao: item.revisao,
            emissao: formatarData(item.emissao),
            condPagamento: item.condicaoPagamento.descricao,
            transportadora: item.transportadora.nome ? item.transportadora.nome : item.codTransportadora,
            redespacho: '  ',
            endereco: item.cliente.endereco,
            itens: item.itens
        };
        const gerarHTML = (item, dataFormatada) => `
            <html>
            <head>
                <style>
                table {
                    font-family: arial, sans-serif;
                    border-collapse: collapse;
                    width: 100%;
                }
                td, th {
                    border: 1px solid #dddddd;
                    text-align: left;
                    padding: 8px;
                }
                tr:nth-child(even) {
                    background-color: #dddddd;
                }
                </style>
            </head>
            <body>
                <p>Olá ${item.cliente.nmCliente},</p>
                <p>Abaixo cotação enviado pelo representante:</p>
                <br/>
                <p>Cotação: ${item.codPedido.substring(3)} || Revisão: ${item.revisao}</p>
                <p>Emiss&atilde;o: ${dataFormatada}</p>
                <table>
                <thead>
                    <tr>
                    <th>Código</th>
                    <th>Produto</th>
                    <th>Local</th>
                    <th>Qtd.</th>
                    <th>Valor</th>
                    <th>Desc.</th>
                    <th>Ipi</th>
                    <th>Total</th>
                    <th>Pedido de compra</th>
                    <th>Obs</th>
                    </tr>
                </thead>
                <tbody>
                    ${item.itens
                    .map(
                        (item) => `
                    <tr>
                        <td>${item.codProduto}</td>
                        <td>${item.nmProduto}</td>
                        <td>${item.codColecao}</td>
                        <td>${parseFloat(item.quantidade).toFixed(2)}</td>
                        <td>${convertDecimal(item.preco.toFixed(2))}</td>
                        <td>${convertDecimal(item.desconto.toFixed(2))}</td>
                        <td>${item.ipi}</td>
                        <td>${convertDecimal(
                        (
                            (parseFloat(item.quantidade) * item.preco - item.desconto) *
                            ((item.ipi / 100) + 1)
                        ).toFixed(2)
                        )}</td>
                        <td>${item.pedido}</td>
                        <td>${item.obs}</td>
                    </tr>
                    `
                    )
                    .join("")}
                </tbody>
                </table>
                <p class="font-bold">Total: R$ ${getTotalCarrinho()}</p>
                <br/>
                <p>Atenciosamente, ${empresa}.</p>
                <br/>
            </body>
            </html>
        `;
        
        const dataFormatada = formatarData(item.emissao);
        const htmlBody = gerarHTML(item, dataFormatada);
        try {
            const response = await api.post("/email/send_email", {
                from_email: "Pedidos Promex Mais <wf.pedidos@promexmais.com.br>",
                to_email: toEmail,
                subject: `Cotação - ${item.codPedido.substring(3)} || Revisão: ${item.revisao}`,
                html_body: htmlBody,
                detPedido: formToPDF,
            });

            if (response.status === 200) {
                await putPedido({ ...item, email: toEmail }, null);
                setErroMassage({ ...erroMassage, email: "" });
                setShow(false);
            } else {
                setErroMassage({ ...erroMassage, email: "Falha no envio do e-mail. Tente novamente." });
            }
            } catch (error) {
            setErroMassage({ ...erroMassage, email: "Falha no envio do e-mail. Verifique sua conexão e tente novamente." });
            } finally {
            setLoadingEmail(false);
        }
    };

    const statusPedidos = (status) => {
        let updatedItem = { ...item };
        setLoadingSubmit(true);
        const closeModal = () => {
            setShowCheck({ open: false, tittleModel: "", type: "" });
            window.location.reload(false);
            setLoadingSubmit(false);
        };
        switch (status) {
            case 'aprovado':
                updatedItem.ativo = '1';
                putPedido(updatedItem, () => closeModal());
                break;
            case 'cancelado':
                updatedItem.ativo = '4';
                putPedido(updatedItem, () => closeModal());
                break;
            case 'reprovado':
                updatedItem.ativo = '3';
                putPedido(updatedItem, () => closeModal());
                break;
            default:
                break;
        }
    };


    const ItemOrcamento = ({ item }) => (
        <div key={item.codPedido + item.revisao}>
            <Table responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Código</th>
                        <th>Produto</th>
                        <th>UM</th>
                        <th>Coleção</th>
                        <th>Qtd.</th>
                        <th>Preço</th>
                        <th>Desconto</th>
                        <th>Ipi</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody className="w-full">
                    {item.itens && item.itens.length > 0 ? 
                        item.itens.map((itemPed, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{itemPed.codProduto}</td>
                                <td>{itemPed.nmProduto}</td>
                                <td>{itemPed.um}</td>
                                <td>{itemPed.codColecao}</td>
                                <td>{itemPed.quantidade.toFixed(2)}</td>
                                <td>{convertDecimal(itemPed.preco.toFixed(2))}</td>
                                <td>{convertDecimal(itemPed.desconto.toFixed(2))}</td>
                                <td>{itemPed.ipi}</td>
                                <td>{convertDecimal((((itemPed.quantidade * itemPed.preco) - itemPed.desconto) * ((itemPed.ipi / 100) + 1)).toFixed(2))}</td>
                            </tr>
                        ))
                        :
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><LoadingIcon /></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    }
                </tbody>
            </Table>
            <div className="flex w-full justify-end">
                <span className="font-bold">Total: R$ {convertDecimal(totalCarrrinho.toFixed(2))}</span>
            </div>
        </div>
    );

    const gerarNovaRevisao = async (itemCotacao) => {
        dispatch(postRevisaoCarrinho(itemCotacao));
        navigate("/orcamentos/editar", { state: { dataCotacao: item } });
    };

    return (
        <div key={item.filial + item.codPedido + item.revisao} className='border-b border-gray-200'>
            <Accordion.Item key={item.filial + item.codPedido + item.revisao} eventKey={item.filial + item.codPedido + item.revisao}>
                {dataCliente && (
                    <Accordion.Header>
                        {item.ativo === '0' && <div className="flex w-4 h-12 bg-gray-400 rounded-full mx-2 md:w-3 md:h-3" />}
                        {item.ativo === '1' && <div className="flex w-4 h-12 bg-blue-400 rounded-full mx-2 md:w-3 md:h-3" />}
                        {item.ativo === '2' && <div className="flex w-4 h-12 bg-green-400 rounded-full mx-2 md:w-3 md:h-3" />}
                        {item.ativo === '3' && <div className="flex w-4 h-12 bg-yellow-400 rounded-full mx-2 md:w-3 md:h-3" />}
                        <div className="grid justify-items-stretch w-full">
                            <p className="text-sm mr-2 my-0"><b>Cotação:</b> {codigoPedido} - <b>Versão:</b> {item.revisao}</p>
                            <p className="text-sm mr-2 my-0"><b>Cliente:</b> {item.cliente.nmCliente} <b>({item.codCliente})</b></p>
                            <p className="text-sm mr-2 my-0"><b>Observação:</b> {item.observacao}</p>
                        </div>
                    </Accordion.Header>
                )}
                <Accordion.Body style={{ overflow: "auto" }}>
                    <div className="flex md:flex-row flex-col md:justify-between w-full">
                        <div>
                            <p className="text-sm mr-2 my-0"><b>E-mail:</b> {item.email}</p>
                            <p className="text-sm mr-2 my-0">
                                <b>Emissão:</b> {converterData(item.emissao)} 
                                {item.ativo === '2' && <><b> || </b><b>Integração:</b> {converterData(item.emissao)}</>}
                            </p>
                            {item.ativo === '2' && <p className="text-sm mr-2 my-0"><b>Número Orçamento:</b> {item.orcamento}</p>}
                        </div>
                    </div>
                    <ItemOrcamento item={item} />
                    <div className="container pt-3">
                        <div className='row justify-end'>
                            {item.ativo === '0' && (
                                <div className='col-sm-2 m-1 px-1'>
                                    <Button disabled={!item} variant="success" size="sm" className='w-100 d-flex align-items-center justify-content-center' onClick={() => setShowCheck({ open: true, tittleModel: `Deseja aprovar cotação ${codigoPedido}?`, type: "aprovado" })}>
                                        <IoCheckmarkSharp className='mr-1' />
                                        Aprovar
                                    </Button>
                                </div>
                            )}
                            {item.ativo === '0' && (
                                <div className='col-sm m-1 px-1'>
                                    <Button disabled={!item} variant="secondary" size="sm" className='w-100 d-flex align-items-center justify-content-center' onClick={() => setShowCheck({ open: true, tittleModel: `Deseja reprovar cotação ${codigoPedido}?`, type: "reprovado" })}>
                                        <IoClose className='mr-1' />
                                        Reprovar
                                    </Button>
                                </div>
                            )}
                            {(item.ativo === '0' || item.ativo === '4') && (
                                <div className='col-sm m-1 px-1'>
                                    <Button disabled={!item} variant="danger" size="sm" className='w-100 d-flex align-items-center justify-content-center' onClick={() => setShowCheck({ open: true, tittleModel: `Deseja cancelar cotação ${codigoPedido}?`, type: "cancelado" })}>
                                        <IoClose className='mr-1' />
                                        Cancelar
                                    </Button>
                                </div>
                            )}
                            {(item.ativo === '0' || item.ativo === '4') && (
                                <div className='col-sm m-1 px-1'>
                                    <Button disabled={!item} variant="warning" size="sm" className='w-100 d-flex align-items-center justify-content-center' onClick={() => gerarNovaRevisao(item.itens)}>
                                        <IoPencil className='mr-1' />
                                        Gerar nova versão
                                    </Button>
                                </div>
                            )}
                            {(item.ativo === '0' || item.ativo === '1') && (
                                <div className='col-sm m-1 px-1'>
                                    <Button disabled={!item} variant="primary" size="sm" className='w-100 d-flex align-items-center justify-content-center' onClick={() => setShow(true)}>
                                        <IoMailOpenOutline className='mr-1' />
                                        Enviar por E-mail
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </Accordion.Body>
                {/* Modal para envio de e-mail */}
                {show && (
                    <Modal
                        show={show}
                        onHide={() => setShow(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        backdrop="static"
                    >
                        <Modal.Header closeButton className="bg-yellow-500">
                            <Modal.Title>Enviar {item.codPedido ? `Cotação ${codigoPedido} - Revisão ${item.revisao}` : ""}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FloatingLabel controlId="floatingInput" label="Email (Separe os e-mails utilizando ; )" className="my-2">
                                <Form.Control value={toEmail} as="input" maxLength={140} onChange={e => setToEmail(e.target.value)} />
                            </FloatingLabel>
                            {erroMassage.email && <p className="text-xs text-red-500">{erroMassage.email}</p>}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button disabled={loadingEmail} variant="success" onClick={() => enviaEmail()}>
                                {loadingEmail ? 'Enviando...' : 'Enviar'}
                            </Button>
                            <Button variant="danger" onClick={() => setShow(false)}>Fechar</Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {/* ModalCheck é sempre renderizado; sua visibilidade é controlada pela prop openModel */}
                <ModalCheck
                    key={`modal-check-${codigoPedido}`}
                    openModel={showCheck.open}
                    header={showCheck.tittleModel}
                    check={() => statusPedidos(showCheck.type)}
                    onHide={() => setShowCheck({ open: false, tittleModel: "", type: "" })}
                    loadingEmail={loadingEmail}
                    loadingSubmit={loadingSubmit}
                />
            </Accordion.Item>
        </div>
    );
};
